import { render, staticRenderFns } from "./occupation.vue?vue&type=template&id=1f5396ca&scoped=true"
import script from "./occupation.vue?vue&type=script&lang=js"
export * from "./occupation.vue?vue&type=script&lang=js"
import style0 from "./occupation.vue?vue&type=style&index=0&id=1f5396ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5396ca",
  null
  
)

export default component.exports